export default "__VITE_ASSET__0b5280ef__"